import React from "react";
import { createTheme } from "@mui/material";
import { pink, purple } from "@mui/material/colors";
import { ThemeProvider } from "@emotion/react";
import ClientMui from "./pages/ClientMui";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "./app.css"

const theme = createTheme({
  palette: {
    primary: purple,
    secondary: pink,
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <ClientMui />
    </ThemeProvider>
  );
}

export default App;
